import angular from 'angular';
import DocumentService from '@/shared/services/DocumentService';
import adminpulse from '@/shared/utils/adminpulse';
import { mapSuggestedMailAddressAngularFilter } from '@/shared/services/ObjectDisplayService';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxInvoicing')
  .controller('SendInvoiceDialogCtrl', [
    '$scope',
    '$element',
    '$timeout',
    '$translate',
    '$filter',
    'templateHttpSvc',
    'resourceFactorySvc',
    'flySvc',
    'close',
    'invoice',
    'useSendInvoiceStrategy',
    'context',
    '$http',
    'appUrls',
    'FileSaver',
    'Blob',
    'dialogsSvc',
    'dataCache',
    '$q',
    sendInvoiceDialogCtrl,
  ]);

function sendInvoiceDialogCtrl(
  $scope,
  $element,
  $timeout,
  $translate,
  $filter,
  templateHttpSvc,
  resourceFactorySvc,
  flySvc,
  close,
  invoice,
  useSendInvoiceStrategy,
  context,
  $http,
  appUrls,
  FileSaver,
  Blob,
  dialogsSvc,
  dataCache,
  $q,
) {
  const emailSendInvoiceStrategies = [1, 6, 7, 8, 9];
  var vm = this;
  vm.useSendInvoiceStrategy = useSendInvoiceStrategy;
  vm.showEmailEditor =
    !useSendInvoiceStrategy ||
    emailSendInvoiceStrategies.some(x => x === invoice.sendInvoiceStrategy);

  vm.templates = [];
  vm.preview = null;
  vm.invoice = invoice;
  vm.sending = false;
  vm.email = {};
  vm.invoiceImage = null;
  vm.loadingPreview = true;
  vm.addresses = [];
  vm.addressLabels = {};
  vm.sendTo = [];
  vm.cc = [];
  vm.bcc = [];
  vm.employeeLabels = {};
  vm.employeeAddresses = [];
  vm.empTo = [];
  vm.empCc = [];
  vm.empBcc = [];

  var showError = function(error) {
    vm.sending = false;
    flySvc.error(error);
  };

  var initializeEmail = function() {
    const data = {
      invoiceId: invoice.id,
      companyId: invoice.companyId,
      relationId: invoice.customer.id,
      invoiceEmailAttachmentOptions: invoice.invoiceEmailAttachmentOptions,
    };

    const invoiceEmailPromise = $http.post(
      `${appUrls.documents}/api/emails/${context === 1 ? 'InvoiceReminder' : 'InvoiceEmail'}`,
      data,
    );

    const isCreditNote = context === 0 && !invoice.isInvoice;
    const emailTemplatesPromise = templateHttpSvc.getTemplates(context);
    const cnEmailTemplatesPromise = isCreditNote ? templateHttpSvc.getTemplates(23) : $q.when([]);

    $q.all([invoiceEmailPromise, emailTemplatesPromise, cnEmailTemplatesPromise]).then(
      ([{ data: email }, templates, cnTemplates]) => {
        if (email) {
          vm.email = email;
        }
        vm.templates = [...(cnTemplates || []), ...(templates || [])].map(item => {
          item.label = $filter('translateList')(item.id, 'template', item.name);
          return item;
        });

        if (context === 0) {
          const { sendInvoiceTemplateId = null, sendCreditNoteTemplateId = null } = invoice;
          if (isCreditNote && sendCreditNoteTemplateId) {
            vm.template = vm.templates.find(x => x.id === sendCreditNoteTemplateId);
          } else if (sendInvoiceTemplateId) {
            vm.template = vm.templates.find(x => x.id === sendInvoiceTemplateId);
          }
        }

        vm.refreshPreview();
      },
      error => {
        flySvc.error(error);
      },
    );
  };
  var showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      console.error(ex);
      //Parsing error?
      flySvc.error();
    }
  };
  vm.generatePreview = function() {
    vm.loadingPreview = true;
    vm.invoiceImage = null;
    $http
      .get(`${appUrls.api}/Api/Invoice/Image/${vm.invoice.id}?now=${new Date().getTime()}`, {
        responseType: 'arraybuffer',
      })
      .then(
        response => {
          vm.loadingPreview = false;
          if (!response || !response.data) return;
          var blob = new Blob([response.data], { type: 'image/png' });
          var reader = new FileReader();
          reader.onload = function(evt) {
            $timeout(function() {
              vm.invoiceImage = evt.target.result;
            }, 0);
          };
          reader.readAsDataURL(blob);
        },
        error => {
          vm.loadingPreview = false;
          showArrayBufferError(error);
        },
      );
  };

  dataCache.ready().then(() => {
    initializeEmail();
    vm.generatePreview();
  });

  var invoiceResource = resourceFactorySvc.get('invoice');

  resourceFactorySvc.get('address').mailSuggestions(
    {
      id: invoice.customer.id,
    },
    function(addresses) {
      vm.addressLabels = addresses.reduce((o, x) => {
        if (!x || !x.emailAddress) return o;
        if (o[x.emailAddress.toLowerCase()]) return o;
        const label = mapSuggestedMailAddressAngularFilter(x, $filter);
        if (!label) return o;
        o[x.emailAddress.toLowerCase()] = label;
        return o;
      }, {});
      vm.addresses = addresses.reduce((a, x) => {
        if (!x) return a;
        if (a.some(y => y.toLowerCase() === x.emailAddress.toLowerCase())) return a;
        a.push(x.emailAddress);
        return a;
      }, []);

      //Add empty input for now, addresses will be loaded when selecting template
      vm.sendTo.push('');
    },
    showError,
  );

  resourceFactorySvc.get('relation').employees(
    { id: invoice.customer.id },
    employees => {
      const users = dataCache
        .getArray('user')
        .filter(x => x.isActive || !x.hidden)
        .map(x => {
          let label = `${x.firstName} ${x.lastName} (${x.email})`;
          const relationEmployees = employees
            .filter(e => e.userId === x.userID)
            .map(e => $filter('translateList')(e.profile, 'employeeprofile'))
            .sort();
          if (relationEmployees.length === 0) return { ...x, label, isRelationEmployee: false };

          return {
            ...x,
            label: `${label} (${relationEmployees.join(', ')})`,
            isRelationEmployee: true,
          };
        })
        .sort(dynamicSortMultiple('-isRelationEmployee', 'firstName', 'lastName', 'email'));
      vm.employeeAddresses = users.map(x => x.email);
      vm.employeeLabels = users.reduce((o, x) => {
        if (!x || !x.email) return o;
        o[x.email.toLowerCase()] = x.label;
        return o;
      }, {});
    },
    showError,
  );
  vm.getAddressLabel = address => {
    if (!address) return address;
    if (typeof address !== 'string') {
      console.log(address);
      return address;
    }
    return vm.addressLabels[address.toLowerCase()] || address;
  };
  vm.getEmpAddressLabel = address => {
    if (!address) return address;
    if (typeof address !== 'string') {
      console.log(address);
      return address;
    }
    return vm.employeeLabels[address.toLowerCase()] || address;
  };
  var retrieveAttachments = function() {
    vm.preview.attachments = [];

    return $http
      .get(appUrls.documents + '/api/documents/links/' + invoice.id + '/2')
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          result.forEach(function(attachment) {
            attachment.isInvoice =
              attachment.documentType === 0 ||
              attachment.documentType === 4 ||
              attachment.documentType === 6;
            vm.preview.attachments.push(attachment);
          });
        }
        return null;
      })
      .catch(function(error) {
        showError(error);
        return null;
      });
  };

  vm.refreshPreview = function() {
    vm.preview = null;
    vm.previewError = null;
    if (!vm.template || !vm.template.id) return;
    invoiceResource.getMail(
      {
        id: invoice.id,
        id2: vm.template.id,
      },
      function(data) {
        vm.preview = data;
        if (data.body === null && data.subject === null) {
          flySvc.message('msgTemplateNotInLanguage');
        }
        if (vm.preview.templateLanguageId) {
          $http
            .get(appUrls.documents + '/api/documents/links/' + vm.preview.templateLanguageId + '/4')
            .then(function(response) {
              var result = response.data;
              if (result && result.length > 0) {
                if (!vm.email.attachments) vm.email.attachments = [];
                result.forEach(function(attachment) {
                  vm.email.attachments.push(attachment);
                });
              }
            })
            .catch(function(error) {
              showError(error);
            });
        }
        vm.sendTo = data.recipients || [''];
        vm.cc = data.cc || [];
        vm.bcc = data.bcc || [];
      },
      function(error) {
        vm.previewError = flySvc.getErrorMsg(error.data.code, error.data.parameters);
        flySvc.error(error);
      },
    );
  };

  vm.addEmailAndSelect = function(list, cssSelector) {
    list.push('');
    $timeout(function() {
      $element
        .find(`.form-group .row.${cssSelector} .dropdown input[type="text"]`)
        .filter(':visible')
        .last()
        .focus();
    }, 200);
  };
  vm.addAddress = function(type) {
    switch (type) {
      case 0:
        return vm.addEmailAndSelect(vm.sendTo, 'email');

      case 1:
        return vm.addEmailAndSelect(vm.cc, 'cc');

      case 2:
        return vm.addEmailAndSelect(vm.bcc, 'bcc');
      case 10:
        return vm.addEmailAndSelect(vm.empTo, 'emp-to');

      case 11:
        return vm.addEmailAndSelect(vm.empCc, 'emp-cc');

      case 12:
        return vm.addEmailAndSelect(vm.empBcc, 'emp-bcc');
    }
  };

  vm.validateEmail = function(value, emptyValid) {
    if (!value && emptyValid) return true;
    return /^[^@]+@.+\..+$/.test(value);
  };

  vm.validate = function() {
    if (!vm.showEmailEditor) return true;
    if (!vm.template || !vm.template.id) return false;
    if (!vm.preview || !vm.preview.subject || !vm.preview.body) return false;
    if (vm.sendTo.length + vm.empTo.length === 0) return false;

    for (var j = 0; j < vm.sendTo.length; j++) {
      if (!vm.validateEmail(vm.sendTo[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    for (var j = 0; j < vm.cc.length; j++) {
      if (!vm.validateEmail(vm.cc[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    for (var j = 0; j < vm.bcc.length; j++) {
      if (!vm.validateEmail(vm.bcc[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    return true;
  };

  vm.save = function() {
    if ($scope.form.$invalid || vm.sending) return;
    if (!vm.validate()) return;

    vm.sending = true;
    vm.preview.recipients = [...vm.sendTo, ...vm.empTo].filter(x => !!x);
    vm.preview.cc = [...vm.cc, ...vm.empCc].filter(x => !!x);
    vm.preview.bcc = [...vm.bcc, ...vm.empBcc].filter(x => !!x);
    vm.preview.emailId = vm.email.id;

    if (vm.email.attachments && vm.email.attachments.length) {
      vm.preview.attachmentDocumentIds = vm.email.attachments.map(x => x.documentId || x.id);
    }

    invoiceResource.sendMail(
      {
        id: invoice.id,
        useSendInvoiceStrategy: vm.useSendInvoiceStrategy,
      },
      vm.preview,
      function() {
        vm.sending = false;
        $element.modal('hide');
        close(true, 500);
      },
      function(error) {
        vm.sending = false;
        flySvc.error(error);
        $element.modal('hide');
        close(false, 500);
      },
    );
  };

  vm.cancel = function() {
    $http
      .delete(appUrls.documents + '/api/emails/' + vm.email.id)
      .then(function(response) {
        var result = response.data;
        close(false, 500);
      })
      .catch(function(error) {
        flySvc.error(error);
        close(false, 500);
        return '';
      });
  };

  vm.downloadAttachment = function(attachment) {
    console.log(attachment);
    DocumentService.download(attachment.documentId || attachment.id);
  };

  vm.uploadAttachment = function(files, invoice) {
    if (!files || files.length < 1) return;

    var newAttachments = [];
    var formData = new FormData();
    formData.append('relationId', invoice.customer.id);

    if (!vm.email.attachments) vm.email.attachments = [];

    files.forEach(function(file) {
      var attachment = {
        name: file.name,
        scanStatus: 1,
        invoiceId: invoice.id,
      };
      vm.email.attachments.push(attachment);
      newAttachments.push(attachment);
      formData.append('data', file.data);
    });

    $http({
      method: 'POST',
      url:
        appUrls.documents + '/api/documents?documentType=9&informQueues=false&recognitionStatus=4',
      headers: {
        'Content-Type': undefined,
      },
      data: formData,
    })
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          result.forEach(function(file) {
            var attachment = newAttachments.find(function(el) {
              return el.name === file.name;
            });
            if (attachment) angular.extend(attachment, file);

            var emailAttachment = vm.email.attachments.find(
              x => x.name.toUpperCase() === file.name.toUpperCase(),
            );
            if (emailAttachment) angular.extend(emailAttachment, file);
          });
        }
      })
      .catch(function(error) {
        newAttachments.forEach(function(attachment) {
          var index = vm.email.attachments.indexOf(attachment);
          vm.email.attachments.splice(index, 1);
        });
        flySvc.error(error);
        return '';
      });
  };

  vm.deleteAttachment = function(attachment) {
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'confirmDeleteEmailAttachment').then(function() {
      // the attachment is a new document that was uploaded in the email modal. Delete the corresponding document
      if (attachment.documentType === 9) {
        $http
          .delete(appUrls.documents + '/api/documents/' + attachment.id)
          .then(function(response) {
            var result = response.data;
            var index = vm.email.attachments.indexOf(attachment);
            vm.email.attachments.splice(index, 1);
          })
          .catch(function(error) {
            flySvc.error(error);
            return '';
          });
      } else if (attachment.documentType === 1) {
        // invoice attachment: delete it from the email, but keep it linked to the invoice
        $http
          .delete(appUrls.documents + '/api/emails/DeleteAttachment/' + attachment.id)
          .then(function(response) {
            var result = response.data;
            var index = vm.email.attachments.indexOf(attachment);
            vm.email.attachments.splice(index, 1);
          })
          .catch(function(error) {
            flySvc.error(error);
            return '';
          });
      } else {
        // the attachment is an existing document, presumably an email attachment. Dont delete the document from the doc-store
        var index = vm.email.attachments.indexOf(attachment);
        vm.email.attachments.splice(index, 1);
      }
    });
  };
}
